export const REFERIN = 'REFERIN';
export const REFEROUT = 'REFEROUT';
